module.exports = __webpack_public_path__ + "img/monitoring-tow-selected.55fcc1d6.svg";